export default "__VITE_ASSET__DOhePzOH__"